import { render, staticRenderFns } from "./AddWithContravention.vue?vue&type=template&id=a21bc618&"
import script from "./AddWithContravention.vue?vue&type=script&lang=js&"
export * from "./AddWithContravention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports